<template lang="pug">
    v-icon.icon(:class="{'expanded' : expanded}") keyboard_backspace
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            expanded: VueTypes.bool.def(false)
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../assets/style/_variables.styl'

    .v-icon.icon
        transform: rotate(180deg)
        transition: transform 0.3s
        color: $theme.white !important

        &.expanded
            transform: rotate(270deg)
            color: $theme.white !important
</style>
